import { Button, Modal, Checkbox } from 'antd';
import { set } from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';

const StyledModal = styled(Modal)`
  .ant-modal-header {
    margin-bottom: 30px;
    color: #02103d;
  }

  .ant-modal-title {
    color: #02103d;
  }

  .ant-modal-close-x {
    color: #02103d;
  }

  .loading-box {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    background-color: #f0f0f0;
    padding: 0.4rem;
    span {
      font-size: 14px;
      color: #02103d;
    }
  }
`;

const StyledP = styled.p`
  font-size: 14px;
`;

const ConfirmScanModal = ({ isVisible, files = [], onCancel, onConfirm }) => {
  const [showUploadCheckbox, setShowUploadCheckbox] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);

  const handleAccept = (files) => {
    onConfirm(files);
    setShowUploadCheckbox(false);
  };

  const handleChangeSelection = (checkedValues) => {
    setSelectedFiles(checkedValues);
  };

  return (
    <StyledModal
      title="Do you want to scan your documents with our AI-powered work order scanner?"
      open={isVisible}
      closable={false}
      onOk={() => handleAccept(files)}
      onCancel={onCancel}
      footer={
        !showUploadCheckbox
          ? [
              <Button key="back" onClick={onCancel}>
                No
              </Button>,
              <Button
                disabled={files.length === 0}
                key="submit"
                type="primary"
                onClick={() =>
                  files.length > 1
                    ? setShowUploadCheckbox(true)
                    : handleAccept(files)
                }
              >
                Yes
              </Button>,
            ]
          : [
              <Button key="back" onClick={() => setShowUploadCheckbox(false)}>
                Cancel
              </Button>,
              <Button
                disabled={selectedFiles.length === 0}
                key="submit"
                type="primary"
                onClick={() => handleAccept(selectedFiles)}
              >
                Scan
              </Button>,
            ]
      }
    >
      <StyledP>
        Scanning this document will automatically extract the relevant
        information and add it to a line item.
      </StyledP>
      {showUploadCheckbox && (
        <div>
          <StyledP>Select files to scan:</StyledP>
          <Checkbox.Group
            value={selectedFiles}
            onChange={handleChangeSelection}
          >
            {files.map((file) => (
              <Checkbox key={file.uid} value={file}>
                {file.name}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </div>
      )}
    </StyledModal>
  );
};

ConfirmScanModal.propTypes = {
  isVisible: PropTypes.bool,
  onCancel: PropTypes.func,
  onConfirm: PropTypes.func,
  files: PropTypes.array,
};

export default ConfirmScanModal;
